// Dashboard Users registration quality page translations (en-US), loaded into dashboard.users.registration by ../en-US.users.js
module.exports = {
  menu: "Registration quality",
  title: "Registration Quality",
  description: "Profile quality and sign-up origin.",
  fields: {
    complete: "Complete profile",
    avatar: "Avatar photo",
    cover: "Cover photo",
    bio: "Bio",
    birthDate: "Birth date",
    gender: "Gender informed",
  },
  filledSub: "{filled} · {empty} without",
  emptySub: "{empty} empty · {filled} filled",
  origins: {
    google: "Google",
    apple: "Apple",
    email: "Email",
  },
  donut: {
    complete: "Complete",
    incomplete: "Incomplete",
    completeSub: "complete",
    originSub: "sign-ups",
  },
  panels: {
    filled: "Filled fields",
    filledNote: "Base on {date}.",
    empty: "Least filled fields",
    emptyNote: "Share of profiles with the field empty — shows where to improve the onboarding.",
    complete: "Complete profiles",
    origin: "Sign-up origin — new in the period",
    originNote: "Count and share per sign-in method.",
  },
  panelInfo: {
    filled: "Active profiles with each field filled in at the end of the period.\nSource: Firebase (profile index).",
    empty: "Active profiles with each field empty at the end of the period.\nSource: Firebase (profile index).",
    complete: "Complete and incomplete active profiles at the end of the period.\nSource: Firebase (profile index).",
    origin: "Accounts created in the period by sign-in method (Google, Apple or e-mail).\nSource: Firebase (Authentication, kept in the profile index).",
  },
};
